// Core
import AuthGuard from "@components/AuthGuard";
import ROUTES from "@constants/routing";
import FilterSectionView from "@views/FilterSectionView";
import MainView from "@views/MainView/MainView";
import NotFoundView from "@views/NotFoundView";
import WelcomeView from "@views/WelcomeView";
import { createBrowserRouter, Navigate } from "react-router-dom";
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to={ROUTES.WELCOME} replace />
  },
  {
    path: ROUTES.CHATBOT,
    element: (
      <AuthGuard>
        <MainView />
      </AuthGuard>
    )
  },
  {
    path: ROUTES.WELCOME,
    element: <WelcomeView />
  },
  {
    path: ROUTES.FILTER_SECTION,
    element: (
      <AuthGuard>
        <FilterSectionView />
      </AuthGuard>
    )
  },
  {
    path: "*",
    element: <NotFoundView />
  }
]);
